export default {
  get (state) {
    // let apiFilters = {}
    // if (state.isHomepage) {
    //   // apiFilters = JSON.parse(JSON.stringify(state.searchFilters))
    //   apiFilters.rowsPerPage = state.searchFilters.rowsPerHomePage
    //   apiFilters.is_front = true
    //   apiFilters.sortBy = 'sortOrder'
    //   apiFilters.page = state.searchFilters.page
    // } else {
    //   apiFilters = JSON.parse(JSON.stringify(state.searchFilters))
    // }
    // apiFilters = JSON.parse(JSON.stringify(state.searchFilters))
    // return apiFilters
    let apiFilters = JSON.parse(JSON.stringify(state.searchFilters))
    apiFilters.isHomepage = state.isHomepage
    if (state.isHomepage) {
      apiFilters.is_front = true
    }
    // Set bedrooms_from and  bedrooms_to when bedroomsCount is set
    if (apiFilters.bedroomsCount !== '' && apiFilters.bedroomsCount !== 'all') {
      if (parseInt(apiFilters.bedroomsCount) === 4) {
        apiFilters.bedrooms_from = 4
      } else {
        apiFilters.bedrooms_to = apiFilters.bedroomsCount
        apiFilters.bedrooms_from = apiFilters.bedroomsCount
      }
      delete(apiFilters.bedroomsCount)
    }
    // Same thing for bathrooms
    if (apiFilters.bathroomCount !== '' && apiFilters.bathroomCount !== 'all') {
      if (parseInt(apiFilters.bathroomCount) === 3) {
        apiFilters.bathrooms_from = 3
      } else {
        apiFilters.bathrooms_to = apiFilters.bathroomCount
        apiFilters.bathrooms_from = apiFilters.bathroomCount
      }
      delete(apiFilters.bathroomCount)
    }
    // Favorites by id
    if (parseInt(apiFilters.favorites) === 1) {
      apiFilters._ids = state.favorites.join(',')
      if (!apiFilters._ids) {
        apiFilters._ids = '5eff8f77e7e04874aa949425' // dummy to show empty list
      }
    }

    // Prep booleans
    let btypes = ['parking', 'pool', 'terrace',
      'aircon', 'pets', 'favorites']
    btypes.forEach(field => {
      if (!['1', 1].includes(apiFilters[field]) && apiFilters[field]) {
        delete(apiFilters[field])
      }
    })
    return apiFilters
  },

  getHash (state) {
    let hash = JSON.stringify(this.get(state))
    return hash
  }
}
